import { FormsService } from "../../../services/forms/forms.service";
import { AuthPayPalUserRequestActionType } from "../types";

export function* activatePaymentCashSaga({ payload }: AuthPayPalUserRequestActionType) {
    try {
        yield FormsService.activateCashPayment();
        window.handleChange({ id: "payment.paymentMethod.cash", value: true });
    } catch (error) {
        console.log("activatePaymentCashSaga", error);
        // yield put(Handle Error);
    }
}
